import { useState } from 'react';
import './App.css';
import TopbarComponent from './component/topbar/topbar';
import HomePage from './pages/landingPage/homePage';
import ContactUs from './pages/contact/contact';
import AboutComponent from './pages/about/about';
import TechnologyComponent from './pages/technology/technology';
import ServicesComponent from './pages/services/services';
import OurProcessComponent from './pages/ourProcess/ourProcess';

function App() {
    const [selectedTab, setSelectedTab] = useState('home')
    const isDarkMode = true
    return (
        <div className="init" id='home'>
            <TopbarComponent selectedTab={selectedTab} isDarkMode={isDarkMode} setSelectedTab={setSelectedTab}/>
            <div className='contentBody'>
                <HomePage/>
                <AboutComponent/>
                <TechnologyComponent/>
                <ServicesComponent/>
                {/* <OurProcessComponent/> */}
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
            </div>
            <ContactUs/>
        </div>
    );
}

export default App;
